export default "__VITE_ASSET__WhXmETqx__"